import { ACCEPTED_PREVIEW_TYPES } from '../../constants';
import { Preview, SelectedPreviewState } from './types';

export const filterPreviews = (previews: Preview[]) =>
  previews.filter((preview) => {
    return ACCEPTED_PREVIEW_TYPES.includes(preview.tag);
  });

export const getInitialPreview = (
  previews: Preview[],
  reorderPreview?: boolean
): SelectedPreviewState =>
  previews.find((preview) =>
    reorderPreview
      ? preview.previewTypeId === 'supplementary'
      : preview.previewTypeId === 'primary'
  ) || previews[0];

export const PRODUCT_PREVIEW_REORDER_LIST = Object.freeze([
  'beaut-flannel', //poster
  'fair-garage', //photographic prints
  'strewn-joey', //art prints
  'outback-mate', //canvas prints
  'googy-veggies', //framed prints
  'ridgy-crumpet', //clocks
  'drain-doco', //bath mats
]);
